module.exports = __webpack_public_path__ + "img/stefan.28e162e.png";